import {
  Component, EventEmitter, HostListener, Input, OnInit,/*  */
  Output
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { CalendarTranslateService } from "app/modules/UIKit/services/calendarTranslate.service";

import { AuthService } from "app/services/user/auth.service";
import { Campaign3Campaign, DistributionCluster3, DistributionList3, DistributionListCluster, DistributionListDetails } from "app/views/campaign-3/models/campaign-3.model";
import { ActionStateService } from "app/views/campaign-3/services/actionstate.service";
import { Campaign3TestService } from "app/views/campaign-3/services/campaign3testservice";
import { DistributionList3Service } from "../services/distribution3.service";


@Component({
  selector: 'app-distribution-list-details-3',
  templateUrl: './distribution-list-details-3.component.html',
  styleUrls: ['./distribution-list-details-3.component.css']
})
export class DistributionListDetails3Component implements OnInit {

  @Input() actionData;

  @Output() refreshCampaignActions = new EventEmitter();
  @Input() loadedDistributionListClusters;
  @Input() distributionListClusters;
  @Input() fatherDistribution: DistributionList3;
  @Output() refreshClusterList: EventEmitter<any> = new EventEmitter<any>();
  distributionToDelete: any;
  displayDeleteDialog: boolean = false;


  menuCreationActive = false;
  showMenu = false;
  currentOpenedRow;

  actionTypes: Array<{ label: string, value: number, code: string }>;
  campaignList: Array<Campaign3Campaign> = [];
  singleAction: any;
  language: string = "it";

  searchedClusters: DistributionCluster3;

  constructor(public router: Router,
    public testService: Campaign3TestService,
    public srvCalendar: CalendarTranslateService,
    public actionStateService: ActionStateService,
    private authService: AuthService,
    private distributionService: DistributionList3Service
  ) {
  }



  ngOnInit() {
    console.log(this.distributionListClusters);
    console.log(this.loadedDistributionListClusters);
  }



  onGetActionDescription(actionTypeId: number): string {

    let retValueObject = this.actionTypes.find(x => x.value == actionTypeId);
    let retVal;
    if (retValueObject == undefined) {
      retVal = 'ID not provided';
    } else {
      retVal = retValueObject.label;
    }
    return retVal;
  }



  //per permettere controllo dei menù a tendina
  initMenuActivated() {
    for (let row of this.distributionListClusters) {
      row["menuActivated"] = false;
    }
  }

  toggleMenu(id: number, indexRow: number) {
    // Save the current state of the clicked menu
    let previousValue = this.distributionListClusters[indexRow].menuActivated;
    // Close all menus
    this.initMenuActivated();
    // Toggle the clicked menu based on its previous state
    this.distributionListClusters[indexRow].menuActivated = !previousValue;
    // Update the current opened row ID and the showMenu state
    this.currentOpenedRow = id;
    this.showMenu = this.distributionListClusters[indexRow].menuActivated;

  }

  onSearchClusterToAdd() {
    console.log('menuCreationActive', this.menuCreationActive);
    this.distributionService.getDistributionListAvailableClusters(this.fatherDistribution.distributionListId).subscribe(
      res => {
        if (res) {
          this.searchedClusters = res;
          this.menuCreationActive = !this.menuCreationActive;
        } else {
          console.warn('No clusters found or response is empty');
        }
      },
      err => {
        console.error('Error while fetching clusters:', err);
      }
    );
  }

  //per chiudere menù alla pressione fuori dalla ziona indicata
  @HostListener('document:click', ['$event'])
  onClick(event: any) {
    // Check if the click is outside the dropdown menu and the button
    if (!event.target.closest('.dropdown-menu') && !event.target.closest('.btn-details')) {
      // Close all menus
      this.initMenuActivated();
      // Update state
      this.showMenu = false;
      this.currentOpenedRow = null;
    }
  }





  closePopupDelete() {
    this.displayDeleteDialog = false;
  }

  protected readonly JSON = JSON;

  // Funzione per verificare se una distribuzione è scaduta
  checkExpiredDistribution(): string {
    return '';
  }


  // Funzione per eliminare la distribuzione
  onDeleteDistribution(distribution: any, index: number): void {
    this.displayDeleteDialog = true;
    this.distributionToDelete = distribution;

  }

  // Funzione per verificare se il termine della distribuzione è raggiunto
  onCheckEndDistribution(): boolean {
    return false;
  }

  onDefinitiveDelete(distributionToDelete: any): void {
    let distributionId = distributionToDelete.id;
    this.distributionService.deleteClusterHeadFromDistributionList(this.fatherDistribution, distributionId).subscribe(res => {
      console.log(res);
      this.displayDeleteDialog = false;
      this.refreshClusterList.emit();
    });


  }

  onClickAnnulla_ModalListDistribuzione() {
    this.menuCreationActive = false;
  }

  onDistributionListSelected(event: DistributionListCluster) {
    console.log(event);
    this.menuCreationActive = false;
  }


  closeAddPopupAndRefresh() {
    this.menuCreationActive = false;
    this.refreshClusterList.emit();
  }



}



// WEBPACK FOOTER //
// ./src/app/views/distribution-list/distribution-list-details-3/distribution-list-details-3.component.ts